export default {
  REDUX_NAMESPACE: 'HUMANIZADAS/PERSISTENT_CACHES',
  RESET_STORE: 'PERSISTENT_CACHES/RESET_STORE',

  CACHE_VALUE: 'PERSISTENT_CACHES/CACHE_VALUE',
  CLEAR_CACHED_VALUE: 'PERSISTENT_CACHES/CLEAR_CACHED_VALUE',
};
